import React from 'react';
import { loomEmbedSrcFromPaste } from '../../../utils/loomEmbed';

type Props = {
  loomUrl: string;
  title: string;
};

const HandbookTrainingLoomPlayer: React.FC<Props> = ({ loomUrl, title }) => {
  const embedSrc = loomEmbedSrcFromPaste(loomUrl);
  if (!embedSrc) {
    return <p className="people-hub-muted">This video link is not a valid Loom URL.</p>;
  }

  return (
    <div className="people-handbook-training-loom-wrap">
      <iframe
        title={title}
        src={embedSrc}
        allowFullScreen
        className="people-handbook-training-loom-iframe"
      />
    </div>
  );
};

export default HandbookTrainingLoomPlayer;
